import { string } from 'yup'

// prevent dashes and underscores in ids
export const idSchema = string().matches(/^[0-9a-zA-Z]+$/)
